<template>
  <div class="images">
    <Hero
      class="hero"
      heading="Images"
    />
    <TextBlock title="Key visuals for coherent look and feel" />
    <div class="surround-all-containers">
      <h2>3D Images</h2>
      <div class="image-container">
        <img src="/images/background-3D/1.png" />
        <img src="/images/background-3D/2.png" />
        <img src="/images/background-3D/3.png" />
        <img src="/images/background-3D/4.png" />
        <img src="/images/background-3D/5.png" />
        <img src="/images/background-3D/6.png" />
        <img src="/images/background-3D/7.png" />
        <img src="/images/background-3D/8.png" />
        <img src="/images/background-3D/9.png" />
        <img src="/images/background-3D/10.png" />
        <img src="/images/background-3D/11.png" />
        <img src="/images/background-3D/12.png" />
        <img src="/images/background-3D/13.png" />
        <img src="/images/background-3D/14.png" />
        <img src="/images/transparent-3D/1.png" />
        <img src="/images/transparent-3D/2.png" />
        <img src="/images/transparent-3D/3.png" />
        <img src="/images/transparent-3D/4.png" />
        <img src="/images/transparent-3D/5.png" />
        <img src="/images/transparent-3D/6.png" />
        <img src="/images/transparent-3D/7.png" />
        <img src="/images/transparent-3D/8.png" />
        <img src="/images/transparent-3D/9.png" />
        <img src="/images/transparent-3D/10.png" />
        <img src="/images/transparent-3D/11.png" />
        <img src="/images/transparent-3D/12.png" />
        <img src="/images/transparent-3D/13.png" />
        <img src="/images/transparent-3D/14.png" />
        <img src="/images/transparent-3D/15.png" />
        <img src="/images/transparent-3D/16.png" />
        <img src="/images/transparent-3D/17.png" />
        <img src="/images/transparent-3D/18.png" />
      </div>
      <div class="download">
        <DownloadButton url="https://seenthis-brand.s3.amazonaws.com/download/images/3d.zip">Download 3D Pack</DownloadButton>
      </div>

      <h2>Nature</h2>
      <div class="image-container">
        <img src="/images/nature/1.jpg" />
        <img src="/images/nature/2.jpg" />
        <img src="/images/nature/3.jpg" />
        <img src="/images/nature/4.jpg" />
        <img src="/images/nature/5.jpg" />
        <img src="/images/nature/6.jpg" />
        <img src="/images/nature/7.jpg" />
        <img src="/images/nature/8.jpg" />
        <img src="/images/nature/9.jpg" />
        <img src="/images/nature/10.jpg" />
        <img src="/images/nature/11.jpg" />
        <img src="/images/nature/12.jpg" />
        <img src="/images/nature/13.jpg" />
        <img src="/images/nature/14.jpg" />
        <img src="/images/nature/15.jpg" />
        <img src="/images/nature/16.jpg" />
        <img src="/images/nature/17.jpg" />
      </div>
      <div class="download">
        <DownloadButton url="https://seenthis-brand.s3.amazonaws.com/download/images/nature.zip">Download Nature Pack</DownloadButton>
      </div>

      <h2>Tech Touch</h2>
      <div class="image-container">
        <img src="/images/tech/1.jpg" />
        <img src="/images/tech/2.jpg" />
        <img src="/images/tech/3.jpg" />
        <img src="/images/tech/4.jpg" />
      </div>
      <div class="download">
        <DownloadButton url="https://seenthis-brand.s3.amazonaws.com/download/images/tech.zip">Download Tech Pack</DownloadButton>
      </div>

      <h2>Screen Life</h2>
      <div class="image-container">
        <img src="/images/screen-life/1.jpeg" />
        <img src="/images/screen-life/2.jpeg" />
        <img src="/images/screen-life/3.jpeg" />
        <img src="/images/screen-life/4.jpeg" />
        <img src="/images/screen-life/5.jpeg" />
        <img src="/images/screen-life/6.jpeg" />
      </div>
      <div class="download">
        <DownloadButton url="https://seenthis-brand.s3.amazonaws.com/download/images/screen-life.zip">Download Screen Life Pack</DownloadButton>
      </div>

      <h2>Cities</h2>
      <div class="image-container">
        <img src="/images/cities/1.jpg" />
        <img src="/images/cities/2.jpg" />
        <img src="/images/cities/3.jpg" />
        <img src="/images/cities/4.jpg" />
        <img src="/images/cities/5.jpg" />
        <img src="/images/cities/6.jpg" />
        <img src="/images/cities/7.jpg" />
        <img src="/images/cities/8.jpg" />
        <img src="/images/cities/9.jpg" />
        <img src="/images/cities/10.jpg" />
        <img src="/images/cities/11.jpg" />
        <img src="/images/cities/12.jpg" />
        <img src="/images/cities/13.jpg" />
        <img src="/images/cities/14.jpg" />
        <img src="/images/cities/15.jpg" />
        <img src="/images/cities/16.jpg" />
      </div>
      <div class="download">
        <DownloadButton url="https://seenthis-brand.s3.amazonaws.com/download/images/cities.zip">Download Cities Pack</DownloadButton>
      </div>

      <h2>People</h2>
      <div class="image-container">
        <img src="/images/people/1.jpg" />
        <img src="/images/people/2.jpg" />
        <img src="/images/people/3.jpg" />
        <img src="/images/people/4.jpg" />
      </div>
      <div class="download">
        <DownloadButton url="https://seenthis-brand.s3.amazonaws.com/download/images/people.zip">Download People Pack</DownloadButton>
      </div>

      <h2>Perspective</h2>
      <div class="image-container">
        <img src="/images/perspective/1.jpg" />
        <img src="/images/perspective/2.jpg" />
        <img src="/images/perspective/3.jpg" />
        <img src="/images/perspective/4.jpg" />
        <img src="/images/perspective/5.jpg" />
        <img src="/images/perspective/6.jpg" />
      </div>
      <div class="download">
        <DownloadButton url="https://seenthis-brand.s3.amazonaws.com/download/images/perspective.zip">Download Perspective Pack</DownloadButton>
      </div>
    </div>
    <ViLinks />
  </div>
</template>

<script>
import Hero from '../components/hero.vue';
import TextBlock from '../components/text-block.vue';
import DownloadButton from '../components/download-button.vue';
import ViLinks from '../components/visual-id-links.vue';

export default {
  name: 'Images',
  components: {
    Hero,
    TextBlock,
    DownloadButton,
    ViLinks,
  },
};
</script>


<style lang="stylus" scoped>

  .surround-all-containers
    max-width: 95rem
    margin: 0 auto 5rem auto
    padding: 0 2rem

    h2
      margin-bottom: 1rem
      text-align: center
    .image-container
      display: flex
      flex-flow: wrap
      justify-content: center
      gap: 1rem

      >*
        height: 8rem

  .download
    max-width: 40rem
    margin: 5rem auto 12rem auto
</style>
